import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DateBlock = ({
  block
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "100",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "detail-100",
      color: "text-core-subtle",
      children: block.label
    }), /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedDateTime, {
        value: new Date(block.value),
        format: "LLL",
        type: "userTz"
      })
    })]
  });
};
export default DateBlock;